<template>
  <div class="about">

    <div class="aboutInfo">
      <h1> Om </h1>
      <p>
        Fiberentreprenad drivs av Kalle Fredlund.
      </p>

      <p>
        Med inovation och ny teknik hittar vi en kostnadseffektiv och <br>
        hållbar lösning inom fiberentreprenad
      </p>
    </div>


    <div class="aboutContact">
      <h1>Välkommen!</h1>

      <p>Telefon</p>
      <p> <a href="tel: +46768-805822">0768 - 80 58 22</a></p>

      <p>E-post</p>
      <p>
        <a v-bind:href=" `mailto:${email}` ">Kalle@Fredlund.nu</a>
      </p>

      <p>Företags sida</p>
      <p>
        <a :href="url"> Facebook </a>
      </p>
    </div>

    <div class="aboutImg">
      <div class="imgBox">
        <img :src="images.img1" class="images" alt="">
        <img :src="images.img2" class="images" alt="">
      </div>


      <div class="message">
        <router-link to="/">Logga in</router-link>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'about',
    components: { },
    data() {
      return {
        url: 'https://www.facebook.com/fredlundfiber/',
        email: 'Kalle@Fredlund.nu',
        images: {
          img1: require('../assets/fiber.jpg'),
          img2: require('../assets/fiber2.jpg')
        },
      }
    },
    methods: {}
  }
</script>

<style scoped lang="scss">

  .about {
    display: flex;
    flex-direction: column;
    color: #333;
    padding: 20px 0;
    margin: 20px 0;
    flex-wrap: wrap;

    .aboutInfo, .aboutContact, .aboutImg, .imgBox {
      margin: 10px 0;
    }

    .imgBox {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-evenly;

      .images {
        border: 2px solid #eee;
        margin: 10px 10px 10px 0;
        max-width: 200px;
        max-height: 170px;
        align-items: center;
        justify-content: center;
        border-radius: 5%;
      }
    }

    h1 {
      font-size: 18pt;
    }

    p {
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
      font-size: 10pt;
      margin: 5px 0;
    }

    a {
      color: gray;
      margin: 5px 0;
    }

    a:hover {
      color: dimgrey;
    }

    .message {
      margin: 45px 0;
      color: #b3b3b3;
      font-size: 12px;

      a, a:hover {
        color: #4CAF50;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/about.vue